var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarPrivateBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 25.332H29.333C30.0663 25.332 30.6663 25.932 30.6663 26.6654C30.6663 27.3987 30.0663 27.9987 29.333 27.9987H2.66634C1.93301 27.9987 1.33301 27.3987 1.33301 26.6654C1.33301 25.932 1.93301 25.332 2.66634 25.332Z",
    fill: "#077CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33366 24H26.667C28.1337 24 29.3203 22.8 29.3203 21.3333L29.3337 6.66667C29.3337 5.2 28.1337 4 26.667 4H5.33366C3.86699 4 2.66699 5.2 2.66699 6.66667V21.3333C2.66699 22.8 3.86699 24 5.33366 24ZM18.856 12H19.4274C20.056 12 20.5703 12.5143 20.5703 13.1429V18.8571C20.5703 19.4857 20.056 20 19.4274 20H12.5703C11.9417 20 11.4274 19.4857 11.4274 18.8571V13.1429C11.4274 12.5143 11.9417 12 12.5703 12H13.1417V10.8571C13.1417 9.28 14.4217 8 15.9988 8C17.576 8 18.856 9.28 18.856 10.8571V12ZM14.856 16C14.856 16.6286 15.3703 17.1429 15.9988 17.1429C16.6274 17.1429 17.1417 16.6286 17.1417 16C17.1417 15.3714 16.6274 14.8571 15.9988 14.8571C15.3703 14.8571 14.856 15.3714 14.856 16ZM14.2846 10.8571V12H17.7131V10.8571C17.7131 9.90857 16.9474 9.14286 15.9988 9.14286C15.0503 9.14286 14.2846 9.90857 14.2846 10.8571Z",
    fill: "#077CA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPrivateBlue);
export default __webpack_public_path__ + "static/media/sidebar_private_blue.a56bade8895302959ba003f880efd334.svg";
export { ForwardRef as ReactComponent };